import React from "react";
import i18n from "../../i18n";
import contryData from "../../constants/country.json";
import { otpLogin, validateOtp } from "../../models/login";
import swal from "sweetalert";
import ReCAPTCHA from "react-google-recaptcha";
import Dropdown from "react-bootstrap/Dropdown";

const codeData = [...contryData];

export class LoginOtp extends React.Component {
  constructor() {
    super();
    this.state = {
      selected_country: {},
      isCaptchaVerified: false,
      captchaToken: "",
      input: {
        dial_code: "+966",
        type: "sms",
      },
      is_otp_sent: false,
      errors: {},
    };
  }

  componentDidMount() {
    const defaultCodeValue = this.getObjectByKeyValue(
      codeData,
      "dial_code",
      "+966"
    );
    this.setState({ selected_country: defaultCodeValue });
    window.scrollTo(0, 0);
  }

  getObjectByKeyValue(jsonArray, key, value) {
    return jsonArray.find((item) => item[key] === value) || null;
  }

  handleChange = (event) => {
    let input = { ...this.state.input };
    input[event.target.name] = event.target.value;
    this.setState({ input });
  };

  handleCaptchaChange = (value) => {
    let input = { ...this.state.input, captcha_token: value };
    this.setState({
      isCaptchaVerified: true,
      captchaToken: value,
      input,
    });
  };

  async sendOtp() {
    const response = await otpLogin(this.state.input);
    if (response.success) {
      this.setState({ is_otp_sent: true });
    } else {
      swal(response.message, JSON.stringify(response.data), "error");
    }
  }

  async validateOtp() {
    const response = await validateOtp(this.state.input);
    if (!response.success) {
      swal(response.message, response.data, "error");
      return;
    }
    if ("token" in response.data) {
      swal(i18n.t("success"), response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then(() => {
        localStorage.setItem("is_logged_in", true);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("mzad_user_info", JSON.stringify(response.data));
        window.location.href =
          response.data.role === "A" ? "/dashboard" : "/";
      });
    } else {
      swal(response.message, JSON.stringify(response.data), "error");
    }
  }

  render() {
    const { is_otp_sent, input, selected_country } = this.state;
    const selected_img = selected_country?.code
      ? selected_country.code.toLowerCase()
      : "";

    return (
      <div className="vh-100 d-flex">
        {/* Left Side - OTP Form */}
        <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
          <div className="w-100" style={{ maxWidth: "400px", padding: "2rem" }}>
            <div className="mb-3">
              <h2 className="fw-bold text-dark mb-2" style={{ fontSize: "2rem" }}>
                {i18n.t("login_using_otp")}
              </h2>
            </div>

            {!is_otp_sent ? (
              <>
                {/* Phone Field with Country Dropdown */}
                <div className="mb-3">
                  <label className="form-label text-dark fw-medium mb-1">
                    {i18n.t("phone_number")}
                  </label>
                  <div className="d-flex align-items-center">
                    {/* Country Code + Flag Dropdown */}
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        className="d-flex align-items-center"
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          padding: "6px 10px",
                          background: "#fff",
                          minWidth: "90px",
                        }}
                      >
                        {this.state.selected_country?.code && (
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/flags/" +
                              this.state.selected_country.code.toLowerCase() +
                              ".svg"
                            }
                            alt="flag"
                            style={{ width: "20px", marginRight: "6px" }}
                          />
                        )}
                        {this.state.selected_country?.dial_code}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{ maxHeight: "250px", overflowY: "auto", minWidth: "200px" }}
                      >
                        {codeData.map((item, i) => (
                          <Dropdown.Item
                            key={i}
                            onClick={() =>
                              this.setState({
                                input: { ...this.state.input, dial_code: item.dial_code },
                                selected_country: item,
                              })
                            }
                            className="d-flex align-items-center"
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/flags/" +
                                item.code.toLowerCase() +
                                ".svg"
                              }
                              alt="flag"
                              style={{ width: "20px", marginRight: "8px" }}
                            />
                            {item.label} ({item.dial_code})
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Phone Number Input */}
                    <input
                      type="text"
                      name="phone"
                      value={this.state.input.phone || ""}
                      onChange={this.handleChange}
                      className="form-control ms-2"
                      placeholder={i18n.t("phone_number")}
                    />
                  </div>
                </div>


                {/* Captcha */}
                <div className="mb-3 text-center">
                  <ReCAPTCHA
                    sitekey="6LceESUpAAAAAAC7C5FaMVWVBIdBRwWzMqR8Wvq7"
                    onChange={this.handleCaptchaChange}
                  />
                </div>

                {/* Send OTP Buttons */}
                <div className="d-flex gap-2">
                  <button
                    className="btn w-50 text-white fw-medium"
                    style={{
                      backgroundColor: "#25D366",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      this.setState(
                        { input: { ...input, type: "whatsapp" } },
                        () => this.sendOtp()
                      );
                    }}
                  >
                    {i18n.t("send_via_whatsapp")}
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* OTP Input */}
                <div className="mb-3">
                  <label className="form-label text-dark fw-medium mb-1">
                    {i18n.t("enter_otp")}
                  </label>
                  <input
                    type="text"
                    name="otp"
                    value={input.otp || ""}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="******"
                  />
                </div>

                <button
                  className="btn w-100 text-white fw-medium"
                  style={{
                    backgroundColor: "#189397",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px",
                    fontSize: "14px",
                  }}
                  onClick={() => this.validateOtp()}
                >
                  {i18n.t("verify_login")}
                </button>
              </>
            )}
          </div>
        </div>

           <div
                    className="col-lg-6 d-none d-lg-block position-relative"
                    style={{
                        backgroundImage: `linear-gradient(135deg, rgba(24,147,151,0.5) 0%, rgba(189,197,50,0.5) 100%),url('/assets/images/auth/banner-1.jpeg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    {/* Background Pattern */}
                    {/* <div className="position-absolute w-100 h-100">
         
                        <div className="position-absolute" style={{ top: '15%', left: '10%' }}>
                            <i className="fa fa-cogs text-white opacity-25" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '25%', right: '15%' }}>
                            <i className="fa fa-wrench text-white opacity-25" style={{ fontSize: '1.5rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '35%', left: '20%' }}>
                            <i className="fa fa-cog text-white opacity-25" style={{ fontSize: '1.8rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ bottom: '30%', right: '10%' }}>
                            <i className="fas fa-envelope text-white opacity-25" style={{ fontSize: '1.6rem' }}></i>
                        </div>
                        <div className="position-absolute" style={{ top: '45%', right: '25%' }}>
                            <i className="fa fa-car text-white opacity-25" style={{ fontSize: '1.4rem' }}></i>
                        </div>

                       
                        {[...Array(15)].map((_, i) => (
                            <div
                                key={i}
                                className="position-absolute text-white opacity-15"
                                style={{
                                    top: `${Math.random() * 80 + 10}%`,
                                    left: `${Math.random() * 80 + 10}%`,
                                    fontSize: '1rem'
                                }}
                            >
                                {['○', , '◯', '◆'][Math.floor(Math.random() * 4)]}
                            </div>
                        ))}
                    </div> */}
                </div>

        {/* FontAwesome CDN */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        />
      </div>
    );
  }
}
